import styled from 'styled-components'

export const StyledPlatformsCard = styled.div`
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  padding: ${({ theme }) => theme.spacing.large};
`

export const PlatformsHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.large};
`

export const PlatformsTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`

export const PlatformsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`

export const PlatformItem = styled.a<{ $isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.default};
  padding: ${({ theme }) => theme.spacing.default};
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  transition: all ${({ theme }) => theme.transitions.fast};
  text-decoration: none;
  color: inherit;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.6 : 1)};

  &:hover {
    ${({ $isDisabled, theme }) =>
      !$isDisabled &&
      `
      border-color: ${theme.colors.border.default};
      box-shadow: ${theme.shadows.sm};
      transform: translateY(-1px);
    `}
  }
`

export const PlatformIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  background: ${({ theme }) => theme.colors.background.tertiary};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  svg {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`

export const PlatformInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const PlatformName = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const PlatformStatus = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
  margin-top: ${({ theme }) => theme.spacing.xsmall};
`

export const StatusDot = styled.div<{ $active: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  background: ${({ theme, $active }) =>
    $active ? theme.colors.success : theme.colors.text.tertiary};
`

export const StatusText = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  color: ${({ theme }) => theme.colors.text.tertiary};
  text-transform: uppercase;
  letter-spacing: ${({ theme }) => theme.typography.letterSpacing.uppercase};
`

export const PlatformLink = styled.div`
  display: flex;
  align-items: center;

  svg {
    color: ${({ theme }) => theme.colors.text.tertiary};
    transition: color ${({ theme }) => theme.transitions.fast};
  }

  ${PlatformItem}:hover & svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const PlatformInitials = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
`
